import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';

import { createRESTContract } from '../../index';
import {
  WebclientAccessGetSchema,
  WebclientAccessUsageParamsSchema,
  WebclientAccessUsageResponseSchema,
} from './webclient-access.schema';

const { WEBCLIENT } = PERMISSIONS;

export const webclientAccessContract = createRESTContract({
  getWebclientAccesses: {
    method: 'GET',
    path: '/webclient-access',
    permissions: [WEBCLIENT.WEBCLIENT_ACCESS_LIST],
    response: z.array(WebclientAccessGetSchema),
  },
  toggleWebclientAccess: {
    method: 'PATCH',
    path: '/webclient-access/toggle',
    permissions: [WEBCLIENT.WEBCLIENT_ACCESS_LIST],
    response: z.void(),
    body: z.undefined(),
  },
  getWebclientAccessUsage: {
    method: 'GET',
    path: '/webclient-access/:configId/usage',
    permissions: [WEBCLIENT.WEBCLIENT_ACCESS_LIST],
    params: WebclientAccessUsageParamsSchema,
    response: WebclientAccessUsageResponseSchema,
  },
});
